module.exports = __webpack_public_path__ + "img/icon_facebook.94e3dc36.svg";